module.exports = __webpack_public_path__ + "img/login_choose_logo.b7ce0663.png";